import { Injectable, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { AppSettings } from '../app.settings';
import { CommonBindingDataService } from './common-binding-data.service';
import { RestApiService } from './rest-api.service';

@Injectable()
export class UiService {

  private currentLanguage = 'en_US';

  private _languageChangeEvent = new EventEmitter<string>();

  private _sidebarToggledEvent = new Subject<string>();

  private sidebarExpandedByHover = false;

  private _LoaderStateChangeEvent = new EventEmitter<string>();

  private _profileUpdateEvent = new Subject<string>();

  showMessageEvent = new Subject<any>();

  message: any = {
    severity: '',
    summary: '',
    detail: ''
  };

  isShowMessage: Boolean = false;

  constructor(
    private common: CommonBindingDataService,
    private restApiService: RestApiService
  ) {

    this.restApiService.shoeErrorMessage.subscribe(result => {
      this.showMessage(result, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  changeLanguage(language: string) {
    this.currentLanguage = language;
    this._languageChangeEvent.emit(language);
  }

  get languageChangeEvent(): EventEmitter<string> {
    return this._languageChangeEvent;
  }

  changeLoaderStatus(state: string) {
    this._LoaderStateChangeEvent.emit(state);
  }
  get LoaderStatusChangeEvent(): EventEmitter<string> {
    return this._LoaderStateChangeEvent;
  }

  sidebarToggled() {
    this._sidebarToggledEvent.next('');
  }

  get sidebarToggledEvent(): Subject<string> {
    return this._sidebarToggledEvent;
  }

  initializeCollapsedSidebar() {
    document.body.classList.add('closed');
  }

  expandSidebarOnHover() {
    if (!document.body.classList.contains('closed')) {
      return;
    }

    this.sidebarExpandedByHover = true;
    document.body.classList.add('sidebar-hover-expanded');
    this.sidebarToggled();
  }

  collapseSidebarOnHoverLeave() {
    if (!this.sidebarExpandedByHover) {
      return;
    }

    this.sidebarExpandedByHover = false;
    document.body.classList.remove('sidebar-hover-expanded');
    this.sidebarToggled();
  }

  toggleSidebar() {
    this.sidebarExpandedByHover = false;
    document.body.classList.remove('sidebar-hover-expanded');
    document.body.classList.toggle('closed');
    this.sidebarToggled();
  }

  profileUpdated() {
    this._profileUpdateEvent.next('');
  }

  get profileUpdatedEvent(): Subject<string> {
    return this._profileUpdateEvent;
  }

  /**
   *
   * @param message : Message that want to show
   * @param type : Type of message Success,Warning and Error
   * @param summary : Optional toast title; the default title for the type is used when it is not given
   */
  showMessage(message: String, type: String = AppSettings.MESSAGE_TYPE.SUCCESS, summary?: string) {
    this.message = '';
    // Message display setting.
    const messageSetting = {
      severity: type,
      summary: '',
      detail: message
    };

    switch (type) {
      case AppSettings.MESSAGE_TYPE.SUCCESS:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.SUCCESS;
        messageSetting.summary = this.common.getLabel('msg_success_summary');
        break;
      case AppSettings.MESSAGE_TYPE.ERROR:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.ERROR;
        messageSetting.summary = this.common.getLabel('msg_error_summary');
        break;
      case AppSettings.MESSAGE_TYPE.WARNING:
        // PrimeNG toast expects 'warn' (not 'warning') for correct styling
        messageSetting.severity = 'warn';
        messageSetting.summary = this.common.getLabel('msg_warning_summary');
        break;
      case AppSettings.MESSAGE_TYPE.INFO:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.INFO;
        messageSetting.summary = this.common.getLabel('msg_info_summary');
        break;
      default:
        messageSetting.severity = AppSettings.MESSAGE_TYPE.SUCCESS;
        messageSetting.summary = this.common.getLabel('msg_success_summary');
        break;
    }
    if (summary) {
      messageSetting.summary = summary;
    }
    this.message = messageSetting;
    this.showMessageEvent.next(this.message);
  }
}
